// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__Qxu_s","title":"AfterFrontImage_title__2wbta"};